export default {
  underlineHover: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
};
